import {
  Connection,
  DocumentServicesObject,
  CompRef,
} from '@wix/document-services-types';
import {
  ComponentRef,
  ElementIdentifier,
} from '@wix/editor-platform-sdk-types';

import { PLATFORM_ROOT_COMP_TYPE } from '../constants';
import { PrimaryConnectionsWithRefs } from '@wix/editor-platform-host-integration-apis';

const hasConnection = (
  connection: PrimaryConnectionsWithRefs | Connection,
  identifier: ElementIdentifier,
) => {
  if (!connection) {
    return false;
  }

  if (identifier.subRole) {
    return (
      identifier.role === connection.role &&
      identifier.subRole === connection.subRole
    );
  }

  return identifier.role === connection.role;
};

export const findConnectionByRole = (
  identifier: ElementIdentifier,
  primaryConnections: PrimaryConnectionsWithRefs[],
) =>
  primaryConnections.find((connection) =>
    hasConnection(connection, identifier),
  );

export const isAppWidget = (
  documentServicesAPI: DocumentServicesObject,
  compRef: CompRef,
) => {
  const compType = documentServicesAPI.components.getType(compRef);

  return compType === PLATFORM_ROOT_COMP_TYPE;
};

export const getCompRefByRole = (
  documentServicesAPI: DocumentServicesObject,
  identifier: ElementIdentifier,
  widgetRef: ComponentRef,
) => {
  const connectedComponents =
    documentServicesAPI.deprecatedOldBadPerformanceApis.components.getChildrenFromFull(
      widgetRef,
      true,
    );

  return connectedComponents.find((compRef) => {
    const primaryConnection =
      documentServicesAPI.platform.controllers.connections.getPrimaryConnection(
        compRef,
      );

    return hasConnection(primaryConnection, identifier);
  });
};

export const getCompRefForNormalizedItem = (
  documentServicesAPI: DocumentServicesObject,
  identifier: ElementIdentifier,
  primaryConnectionOfConnected: PrimaryConnectionsWithRefs[],
) => {
  const connectionByRole = findConnectionByRole(
    identifier,
    primaryConnectionOfConnected,
  );

  if (!connectionByRole) {
    return;
  }

  const { compRef } = connectionByRole;

  const compRefIsAppWidget = isAppWidget(documentServicesAPI, compRef);

  if (compRefIsAppWidget) {
    return documentServicesAPI.deprecatedOldBadPerformanceApis.components.getContainer(
      compRef,
    );
  }

  return compRef;
};
